  <template>
  <div>
    <div class="title">
      <!-- <span class="navigation">{{$route.meta.title}}</span> -->
      <!-- <img src="../../assets/iconImg/gemlogo1.png" alt class="gemoimgIcon"> -->
      <!-- <span class="icon">
        <i class="iconfont icon-sousuo1"></i>
      </span>-->
      <!-- <img src="http://img.tutubox.cn/gemMHomeTitle3.png" class="gemoImg" alt> -->
      <!-- swiper -->
      <van-swipe :autoplay="3000" indicator-color="#fff">
        <van-swipe-item v-for="(item, index) in images" :key="index">
          <img :src="item">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="hot-pavilion">
      <div class="pavilion-title">展馆</div>
      <ul>
        <li
          v-for="item in hotPavilion"
          :key="item.id"
          class="pavilion-item"
          @click="BrowsePavilion(item)"
        >
          <img :src="item.thumbnail | thumbnail(698,462)">
          <div class="infoName">
            <span class="name">{{item.name}}</span>
            <span class="createTime">{{item.createTime}}</span>
          </div>
          <div class="star">
            <p>
              <i class="iconfont icon-yanjing_xianshi_o"></i>
              <span>{{item.view}}</span>
            </p>
            <p>
              <i class="iconfont icon-zanshoushi"></i>
              <span>{{item.sn}}</span>
            </p>
          </div>
          <!-- <img :src="item.thumbnail | thumbnail(225,150) "> -->
          <!-- <img src="http://img.tutubox.cn/gemdefult.png"> -->
          <!-- <div class="pavilion-info">
            <div class="name">{{item.name}}</div>
            <div class="number">
              <span class="view">
                <i class="iconfont icon-yanjing_xianshi_o"></i>
                {{item.view}}
              </span>
              <span>
                <i class="iconfont icon-zanshoushi"></i>
                {{item.sn}}
              </span>
            </div>
            <div class="createTime">{{item.createTime}}创建</div>
          </div>
          <span class="indicate">
            GO
            <i class="iconfont icon-fangxiang1"></i>
          </span>-->
        </li>
      </ul>
    </div>
    <div class="hot-model">
      <div class="model-title">珠宝</div>
      <ul class="model-wrapper">
        <li v-for="item in hotModel" :key="item.id" class="model-item" @click="BrowseModel(item)">
          <img :src="item.thumbnail | thumbnail(340,340) ">
          <div class="model-name">{{item.name}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { hotModel, hotPavilion } from "@/api/homeReq";
import { Toast, Swipe, SwipeItem } from "vant";
import zhenkuImg1 from "../../assets/iconImg/zhenku1.png";
import zhenkuImg2 from "../../assets/iconImg/zhenku2.png";
import zhenkuImg3 from "../../assets/iconImg/zhenku3.png";
import {Share} from '@/api/wechat';

export default {
  data() {
    return {
      hotModel: [],
      hotPavilion: [],
      images: [zhenkuImg1, zhenkuImg2, zhenkuImg3]
    };
  },

  components: {
    [Toast.name]: Toast,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },

  created() {
    if(this.$isWeChat) {  
      Share('珍库', 'http://img.tutubox.cn/gemIcon.jpg', '开启你的虚拟展馆', window.location.href) 
    }
    hotModel().then(res => {
      this.hotModel = res.list;
    }),
      hotPavilion().then(res => {
        this.hotPavilion = res.list.slice(0, 2);
      });
  },

  methods: {
    BrowseModel(item) {
      if (item.isAlbum) {
        // type : vertical为竖向，transverse为横向
        this.$store.dispatch("ChangePreviewShow", {
          item,
          show: true,
          type: "vertical"
        });
        return;
      }
      if (!item.modelId) {
        Toast("没有上传模型");
        return;
      }
      this.$router.push({
        path: `/model-view/${item.id}`
      });
    },
    BrowsePavilion(item) {
      if (item.gems.length === 0) {
        Toast("没有布置展馆");
        return;
      }
      this.$router.push({
        path: `/pavilion-view/${item.id}`
      });
    }
  }
};
</script>

<style scoped lang="less">
// 注释为备份
.title {
  position: relative;
  width: 100%;
  /deep/ .van-swipe {
    width: 100%;
    height: 100%;
  }
  /deep/ .van-swipe-item > img {
    width: 100%;
    height: 100%;
    // object-fit: cover
  }
  .navigation {
    position: absolute;
    top: 20px;
    left: 15px;
    font-size: 28px;
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
  }
  .icon {
    position: absolute;
    top: 30px;
    right: 15px;
    color: #fff;
    font-size: 20px;
  }
  .gemoimgIcon {
    width: 25%;
    position: absolute;
    top: 20px;
    left: 52%;
    transform: translateX(-50%);
  }
  .gemoImg {
    position: absolute;
    top: 88px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
  }
}
.hot-pavilion {
  margin-top: 12%;
  padding: 0 13px;
  ul {
    margin-top: 10px;
  }
  .pavilion-title {
    width: 100%;
    position: relative;
    padding-left: 10px;
    font-size: 18px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    box-sizing: border-box;
    // margin-left: 3%;
    &::after {
      position: absolute;
      content: "";
      left: 0;
      top: 18%;
      width: 3px;
      height: 17px;
      background: rgba(119, 97, 207, 1);
    }
  }
  .pavilion-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0 0 15px 0;
    background-color: #fff;
    border-radius: 6px;
    img {
      width: 100%;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
    .infoName {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      padding: 0 14px;
      box-sizing: border-box;
      .name {
        font-size: 18px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      .createTime {
        font-size: 13px;
        font-weight: 400;
        color: rgba(168, 168, 168, 1);
      }
    }
    .star {
      margin: 17px 0 18px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 14px;
      box-sizing: border-box;
      p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 22px;
        i {
          color: #a8a8a8;
          font-size: 16px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: rgba(168, 168, 168, 1);
          margin-left: 6px;
        }
      }
    }
  }
}
.hot-model {
  margin-top: 30px;
  padding: 0 13px;
  .model-title {
    position: relative;
    // border-left: 3px solid rgba(119, 97, 207, 1);
    padding-left: 10px;
    font-size: 18px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    &::after {
      position: absolute;
      content: "";
      left: 0;
      top: 18%;
      width: 3px;
      height: 17px;
      background: rgba(119, 97, 207, 1);
    }
  }
  .model-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    padding-bottom: 49px;
    .model-item {
      width: 48%;
      margin-bottom: 15px;
      text-align: center;
      background: #fff;
      &:nth-child(3n) {
        margin-right: 0px;
      }
      img {
        // width: 100%;
        // height: 45.34vw;
        // box-shadow: 1px 6px 21px 0px rgba(66, 83, 103, 0.08);
        // border-radius: 5px;
        width: 100%;
          height: 45.34vw;
          vertical-align: middle;
      }
      .model-name {
        background-color: #fff;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        // width: 85%;
        // text-align: left;
        // // margin-top: 5px;
        overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          text-align: left;
          color: rgba(51, 51, 51, 1);
          font-size: 14px;
          font-weight: 400;
          padding: 8% 0 7% 9%; 
          box-sizing: border-box;
      }
    }
  }
}
</style>